import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

@Injectable()
export class RefreshDashboardDataService {
  private refreshDashboardSubject = new Subject<void>();
  public refreshDashboardSubject$ = this.refreshDashboardSubject.asObservable();

  private refreshDataSubject = new Subject<Date>();
  public refreshData$ = this.refreshDataSubject
    .asObservable()
    .pipe(distinctUntilChanged());

  public refreshData(refreshedDate?: Date) {
    this.refreshDataSubject.next(refreshedDate);
  }

  public refreshDashboard(): void {
    this.refreshDashboardSubject.next();
  }
}
